<template>
  <div class="SearchStockOptions">
    <div class="SearchStock flex">
      <div class="flex search-stock-container SearchStock-indice">
        <div class="dropdown-wrapper">
          <input type="text" v-model="search_indice_text" placeholder="Search e.g NIFTY, FINNIFTY" class="custom-seach-input" @input="searchStockList(search_indice_text)" @keydown.down.prevent="highlightNextIndice" @keydown.up.prevent="highlightPrevIndice" @keydown.enter.prevent="selectHighlightedIndice" />
          <div v-if="filtered_indice_list.length" class="dropdown">
            <ul class="dropdown-list">
              <li v-for="(stock, index) in filtered_indice_list" :key="stock.id" :class="{ highlighted: index === highlightedIndiceIndex }" @click="selectIndice(stock)" @mouseover="highlightIndice(index)">
                <span class="searched-stock-title">
                  {{ stock.name || stock.title }}
                </span>
                <span class="input-label-gray" v-if="stock.symbol || stock.expiry">({{ stock.symbol || moment(stock.expiry).format('DD MMM YYYY') }})</span>
              </li>
            </ul>
          </div>
          <i class="el-icon-search search-icon" style="top: 8px" v-if="!search_indice_text"></i>
          <i class="el-icon-circle-close cross-icon" v-if="search_indice_text.trim()" @click="clearInputField" />
        </div>
      </div>
    </div>

    <div class="SearchStock flex" v-if="$router.currentRoute.path != '/publish-recommendation-options'">
      <div class="flex search-stock-container SearchStock-strike-price">
        <div class="dropdown-wrapper">
          <input type="text" v-model="search_stock_text" placeholder="Strike Price" class="custom-seach-input" @input="filterStrikeData" @focus="showStrikeDropdownOnFocus" @keydown.down.prevent="highlightNextStrike" @keydown.up.prevent="highlightPrevStrike" @keydown.enter.prevent="selectHighlightedStrike" />
          <div v-if="filtered_strike_data.length" class="dropdown">
            <ul class="dropdown-list">
              <li v-for="(strike, index) in filtered_strike_data" :key="strike.id" :class="{ highlighted: index === highlightedStrikeIndex }" @click="selectStrike(strike)" @mouseover="highlightStrike(index)">
                {{ strike.label }}
              </li>
            </ul>
          </div>
          <i class="el-icon-search search-icon" style="top: 8px" v-if="!search_stock_text"></i>
          <i class="el-icon-circle-close cross-icon" v-if="search_stock_text.trim()" @click="clearStrikePriceAndEmit(selectedStock)" />
        </div>
      </div>
    </div>

    <div v-if="$router.currentRoute.path !== '/publish-recommendation-options'" class="clear-button" :style="{ cursor: search_stock ? 'pointer' : 'default' }" @click="clearInputField()">Clear</div>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';
import { EventBus } from '../eventBus';
import { derivativesApiCall } from '../mixins/DerivativesApi';
import moment from 'moment';
import debounce from 'lodash/debounce';

export default {
  name: 'SearchStock',
  mixins: [derivativesApiCall],
  data() {
    return {
      moment,
      search_stock: '',
      selectedStock: {},
      stocksList: [],
      strikePrice: '',
      strikeData: [],
      search_indice_text: '',
      search_stock_text: '',
      filtered_indice_list: [],
      filtered_strike_data: [],
      highlightedIndiceIndex: -1,
      highlightedStrikeIndex: -1,
      isSearchDisable: false,
    };
  },
  created() {
    this.searchStockList = debounce(this.searchStockListHandler, 300);
  },
  mounted() {
    EventBus.$on('clearedSelectedFilter', () => (this.search_stock = ''));
    EventBus.$on('selectedSector', () => (this.search_stock = ''));
    EventBus.$on('selectedSearchedExpert', () => (this.search_stock = ''));
    EventBus.$on('selectPreviousStock', (stock) => {
      console.log(stock);

      this.search_stock = stock.title;
      this.search_indice_text = stock.title + ' ' + moment(stock.expiry).format('DD MMMM YYYY');
      console.log(this.search_stock);
    });
    EventBus.$on('removeSelectedStock', () => {
      this.search_stock = '';
      this.search_indice_text = '';
    });
    EventBus.$on('disableSearch', (val) => (this.isSearchDisable = val));
  },
  methods: {
    searchStockListHandler(query) {
      if (!query) return;

      serverAddr
        .post(`/options/indices?q=${query}`)
        .then(({ data }) => {
          this.stocksList = data.status ? data.data : [];
          this.filtered_indice_list = this.stocksList;
        })
        .catch((err) => console.error('Error fetching indices:', err));
    },
    clearInputField() {
      this.search_stock = '';
      this.strikePrice = '';
      this.strikeData = [];
      this.search_stock_text = '';
      this.search_indice_text = '';
      EventBus.$emit('selectedStock', '');
    },
    clearStrikePriceAndEmit(stockDetails) {
      // Option 1: Set strike_price to null
      // const updatedStock = { ...stockDetails, strike_price: null };

      // Option 2: Remove strike_price completely
      const { strike_price, ...updatedStock } = stockDetails;

      console.log(updatedStock);

      EventBus.$emit('selectedStock', updatedStock);
    },
    handleStock(item) {
      const stock = this.stocksList.find((e) => e.id === item);
      if (stock) {
        EventBus.$emit('selectedStock', stock);
        this.selectedStock = stock;
        this.getStrikeDataCalBack();
      } else {
        EventBus.$emit('selectedStock', '');
        this.strikePrice = '';
        this.strikeData = [];
      }
    },
    showStrikeDropdownOnFocus() {
      this.filtered_strike_data = [...this.strikeData];
    },
    filterStrikeData() {
      this.filtered_strike_data = this.strikeData.filter((s) => s.label.toLowerCase().includes(this.search_stock_text.toLowerCase()));
    },
    highlightNextIndice() {
      if (this.highlightedIndiceIndex < this.filtered_indice_list.length - 1) this.highlightedIndiceIndex++;
    },
    highlightPrevIndice() {
      if (this.highlightedIndiceIndex > 0) this.highlightedIndiceIndex--;
    },
    selectHighlightedIndice() {
      if (this.highlightedIndiceIndex >= 0) this.selectIndice(this.filtered_indice_list[this.highlightedIndiceIndex]);
    },
    highlightIndice(index) {
      this.highlightedIndiceIndex = index;
    },
    selectIndice(stock) {
      this.search_indice_text = stock.title + ' ' + moment(stock.expiry).format('DD MMMM YYYY');
      this.search_stock = stock.id;
      this.handleStock(stock.id);
      this.filtered_indice_list = [];
    },
    highlightNextStrike() {
      if (this.highlightedStrikeIndex < this.filtered_strike_data.length - 1) this.highlightedStrikeIndex++;
    },
    highlightPrevStrike() {
      if (this.highlightedStrikeIndex > 0) this.highlightedStrikeIndex--;
    },
    selectHighlightedStrike() {
      if (this.highlightedStrikeIndex >= 0) this.selectStrike(this.filtered_strike_data[this.highlightedStrikeIndex]);
    },
    highlightStrike(index) {
      this.highlightedStrikeIndex = index;
    },
    selectStrike(strike) {
      this.search_stock = strike.id;
      this.search_stock_text = strike.label;
      this.getSelectedStrikeData(strike.id);
      this.filtered_strike_data = [];
    },
    getSelectedStrikeData(item) {
      const strike = this.strikeData.find((e) => e.id === item);
      EventBus.$emit('selectedStrike', strike || '');
      if (!strike) this.strikePrice = '';
    },
  },
  beforeDestroy() {
    EventBus.$off();
  },
};
</script>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.SearchStockOptions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .clear-button {
    font-size: 11px;
    border: 1px solid;
    padding: 2px 8px;
    border-radius: 10px;
    color: #409eff;
    margin-left: 5px;
  }

  .SearchStock-indice {
    width: 320px;
  }

  .SearchStock-strike-price {
    width: 200px;
  }
}

.SearchStockOptions {
  .dropdown-wrapper {
    position: relative;
    width: 100%;
    margin: 3px 0;
    margin-right: 15px;

    input {
      background-color: #fff;
      border-radius: 40px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      height: 33px;
      font-size: 17px;
      padding: 0 15px;
      width: 100%;
      outline: none;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }

  .dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 100%;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000; // increased z-index
    margin-top: 5px;
  }

  .dropdown-list {
    max-height: 150px;
    overflow-y: auto;
    margin: 0;
    padding: 0;
    list-style: none;
    border-radius: 4px; // added for smooth corners
    background-color: white; // explicitly set for consistent background

    .searched-stock-title {
      font-size: 12px !important;
    }
  }

  .dropdown-list li {
    height: 34px;
    line-height: 34px;
    font-size: 12px !important;
    padding: 0 20px;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    color: #878787;
    transition: background-color 0.2s ease;
  }

  .dropdown-list li:hover,
  .dropdown-list li.highlighted {
    background-color: #f5f7fa;
    color: $primary-theme-color;
  }

  // @media screen and (max-width: 768px) {
  //   .SearchStock .search-stock-container {
  //     min-width: 130px !important;
  //     width: 100%;
  //   }
  // }
  // @media screen and (max-width: 500px) {
  //   .dropdown-wrapper {
  //     width: 220px;
  //   }
  // }
}

// @media screen and (max-width: 768px) {
//   .SearchStockOptions {
//     .search-stock-container {
//       max-width: 375px !important;
//       width: 100%;

//       .el-input--small {
//         font-size: 11px;
//       }
//     }
//   }

//   .SearchStock {
//     .strike-price-search-stock-container {
//       max-width: 110px !important;
//     }
//   }
// }
</style> 